export default (btn, active) => {
  btn.classList[active ? 'remove' : 'add']('animate-pulse');
  const icon = btn.querySelector('.icon');
  if (icon) {
    icon.style.display = active ? '' : 'none';
  }
  btn.querySelector('.load-ring').style.display = !active ? '' : 'none';
};
